import styled from 'styled-components';
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion';

import variables from '../../../styles/variables';
import RedArrow from '../../../images/arrow_icon_red.svg';

interface LegalContainerProps {
  readonly pageId?: string;
  readonly reduceMargin?: boolean;
}

export const StyledAccordionBody = styled(AccordionItemPanel)`
  width: 100%;
  margin-bottom: 2rem;
`;

export const LegalWrapper = styled(Accordion)`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${variables.defaultWidth}px;
  padding: 0 ${variables.layoutPadding}rem;
  margin: 0 auto;
  @media screen and (max-width: 1023px) {
    padding: 0 10px;
    margin-bottom: 20px;
  }
  @media screen and (max-width: 767px) {
    padding: 0;
  }
  &.phoneDetails {
    padding: 0;
  }
`;

export const StyledAccordionItemTitle = styled(AccordionItemHeading)`
  background-color: transparent;
  width: 175px;
  padding: 1rem 0;
  cursor: pointer;
  @media screen and (max-width: 1023px) {
    width: 130px;
  }
`;

export const StyledAccordionArrow = styled.span`
  position: normal;
  display: inline-block;
  background: url(${RedArrow}) no-repeat;
  width: 7px;
  height: 8px;
  transform: rotate(90deg);
  margin-left: 5px;
  margin-top: 3px;
`;

export const StyledAccordionItemButton = styled(AccordionItemButton)`
  display: flex;
  position: relative;
  padding: 1rem 0;
  &[aria-expanded='true'] ${StyledAccordionArrow} {
    transform: rotate(180deg);
    margin-bottom: 1px;
    margin-top: 2px;
  }
`;

export const LegalContainer = styled.section<LegalContainerProps>`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0 ${variables.layoutPadding}rem;
  align-items: center;
  justify-content: center;
  margin-top: ${({ pageId }) => pageId === 'homepage'
    || pageId === 'connect'
    || pageId === 'redemption'
    || pageId === 'device-protection-plan'
    ? '0' : '100px'};
  color: #3a3a3a;
  @media screen and (max-width: 767px) {
    width: 100%;
    justify-content: flex-start;
    margin-top: 0;
    padding: 0 ${variables.mobileLayoutPadding};
  }

  &.phoneDetailsPage {
    padding: 0;
    margin-top: 0px;

    p {
      margin-bottom: 0;
      font-size: 11px;
    }
    ${LegalWrapper} {
      padding: 0;
      margin-bottom: 5px;
    }
    ${StyledAccordionBody} {
      margin-bottom: 0;
    }
    ${StyledAccordionItemTitle} {
      padding: 0;
    }
    ${StyledAccordionItemButton} {
      padding: 5px 0px 10px;
    }
  }
`;

export const StyledAccordionItem = styled(AccordionItem)`
  width: 100%;
`;

export const Title = styled.span`
  margin: 0;
  letter-spacing: 0.5px;
  font-size: 12px;
  font-weight: normal;
  line-height: 14px;
`;
